import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 28,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  title: {
    fontSize: 18,
    marginBottom: 8,
  },
  section: {
    marginTop: 12,
    marginBottom: 6,
    fontSize: 12,
    fontFamily: "Helvetica-Bold",
  },
  row: {
    flexDirection: "row",
    marginBottom: 2,
  },
  label: {
    width: "32%",
    fontFamily: "Helvetica-Bold",
  },
  value: {
    width: "68%",
  },
  card: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 4,
    padding: 8,
    marginBottom: 8,
  },
});

const textValue = (value, fallback = "None") => {
  if (Array.isArray(value)) return value.length ? value.join(", ") : fallback;
  if (value === null || value === undefined || value === "") return fallback;
  return String(value);
};

function MarkerList({ markers }) {
  return (
    <View>
      {markers?.length ? (
        markers.map((marker, index) => (
          <View
            key={marker.id || `${marker.lat}-${marker.lng}-${marker.label}-${index}`}
            style={styles.card}
          >
            <Text>{marker.label || "Marker"}</Text>
            <Text>{`Icon: ${marker.templateTitle || "Custom"}`}</Text>
            <Text>{`Position: ${marker.lat}, ${marker.lng}`}</Text>
          </View>
        ))
      ) : (
        <Text>None</Text>
      )}
    </View>
  );
}

function MapBookPDF({ orchard, blocks }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>
          {orchard?.orchardName || orchard?.id || "Orchard"} Map Book
        </Text>
        <Text>{`Orchard ID: ${orchard?.id || "-"}`}</Text>

        <Text style={styles.section}>Orchard Notes</Text>
        <Text>{textValue(orchard?.notes)}</Text>

        <Text style={styles.section}>Orchard Markers</Text>
        <MarkerList markers={orchard?.markers} />

        <Text style={styles.section}>Orchard Areas</Text>
        {orchard?.areas?.length ? (
          orchard.areas.map((area) => (
            <View key={area.id || area.area} style={styles.card}>
              <Text>{area.area || "Area"}</Text>
              <Text>{`Site area: ${area.site ? "Yes" : "No"}`}</Text>
              <Text>{`Coordinates: ${area.coordinates?.length || 0}`}</Text>
            </View>
          ))
        ) : (
          <Text>None</Text>
        )}
      </Page>

      {blocks?.map((block) => (
        <Page key={block.id} size="A4" style={styles.page}>
          <Text style={styles.title}>{block.blockId || block.id || "Block"} Map</Text>
          <Text>{`Block ID: ${block.id || "-"}`}</Text>

          <Text style={styles.section}>Block Notes</Text>
          <Text>{textValue(block?.notes)}</Text>

          <Text style={styles.section}>Block Markers</Text>
          <MarkerList markers={block?.markers} />

          <Text style={styles.section}>Block Areas</Text>
          {block?.areas?.length ? (
            block.areas.map((area) => (
              <View key={area.id || area.area} style={styles.card}>
                <Text>{area.area || "Area"}</Text>
                <Text>{`Coordinates: ${area.coordinates?.length || 0}`}</Text>
              </View>
            ))
          ) : (
            <Text>None</Text>
          )}

          <Text style={styles.section}>Rows</Text>
          {block?.rows?.length ? (
            block.rows.map((row) => (
              <View key={row.id || row.RowSerial} style={styles.card}>
                <Text>{row.RowID || row.RowSerial || "Row"}</Text>
                <Text>{`Variety: ${row.Variety || "-"}`}</Text>
              </View>
            ))
          ) : (
            <Text>None</Text>
          )}
        </Page>
      ))}
    </Document>
  );
}

export default MapBookPDF;
